import { Phone, Users, Mail, MapPin, MoreHorizontal, Tag } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  PHONE: Phone,
  MEETING: Users,
  EMAIL: Mail,
  VISIT: MapPin,
  OTHER: MoreHorizontal,
}

/** Mapuje kod typu akcji na ikonę z lucide-react. Fallback `Tag` dla custom codes
 *  (klient może dodać własne typy przez admin UI - dostają generic ikonę). */
export function iconForActionType(code: string | null | undefined): LucideIcon {
  if (!code) return Tag
  return ICONS[code] ?? Tag
}
